/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseListResponseOfImpersonationLogModel } from '../api-models';
// @ts-ignore
import { CreateBulkUserRoleMapping } from '../api-models';
// @ts-ignore
import { CreatePermissionDTO } from '../api-models';
// @ts-ignore
import { CreateRoleDTO } from '../api-models';
// @ts-ignore
import { CreateUserRoleDTO } from '../api-models';
// @ts-ignore
import { GroupWiseRoleEmployeeInformationDTO } from '../api-models';
// @ts-ignore
import { LoggOutRequest } from '../api-models';
// @ts-ignore
import { UpdateRoleDTO } from '../api-models';
// @ts-ignore
import { ViewPermissionDTO } from '../api-models';
// @ts-ignore
import { ViewRoleDTO } from '../api-models';
// @ts-ignore
import { ViewUserRoleDTO } from '../api-models';
/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [impersonatorUserName] 
         * @param {string} [userName] 
         * @param {number} [durationInDays] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationLogsGet: async (impersonatorUserName?: string, userName?: string, durationInDays?: number, searchQuery?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/impersonation-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (impersonatorUserName !== undefined) {
                localVarQueryParameter['impersonatorUserName'] = impersonatorUserName;
            }

            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }

            if (durationInDays !== undefined) {
                localVarQueryParameter['durationInDays'] = durationInDays;
            }

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoggOutRequest} [loggOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutPost: async (loggOutRequest?: LoggOutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loggOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePermissionDTO} [createPermissionDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionPost: async (createPermissionDTO?: CreatePermissionDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPermissionDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdDelete: async (permissionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('authPermissionsPermissionIdDelete', 'permissionId', permissionId)
            const localVarPath = `/auth/permissions/{permissionId}`
                .replace(`{${"permissionId"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdGet: async (permissionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('authPermissionsPermissionIdGet', 'permissionId', permissionId)
            const localVarPath = `/auth/permissions/{permissionId}`
                .replace(`{${"permissionId"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {ViewPermissionDTO} [viewPermissionDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdPut: async (permissionId: number, viewPermissionDTO?: ViewPermissionDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'permissionId' is not null or undefined
            assertParamExists('authPermissionsPermissionIdPut', 'permissionId', permissionId)
            const localVarPath = `/auth/permissions/{permissionId}`
                .replace(`{${"permissionId"}}`, encodeURIComponent(String(permissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(viewPermissionDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRoleDTO} [createRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolePost: async (createRoleDTO?: CreateRoleDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRoleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdDelete: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('authRolesRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/auth/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdGet: async (roleId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('authRolesRoleIdGet', 'roleId', roleId)
            const localVarPath = `/auth/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {UpdateRoleDTO} [updateRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdPut: async (roleId: number, updateRoleDTO?: UpdateRoleDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('authRolesRoleIdPut', 'roleId', roleId)
            const localVarPath = `/auth/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTestGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserRoleDTO} [createUserRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserMapRolePost: async (createUserRoleDTO?: CreateUserRoleDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/user/map-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRoleDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateBulkUserRoleMapping} [createBulkUserRoleMapping] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersBulkMapRolePut: async (createBulkUserRoleMapping?: CreateBulkUserRoleMapping, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/users/bulk/map-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBulkUserRoleMapping, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user role information by employee name.
         * @param {string} [employeeName] The name of the employee (optional).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersGet: async (employeeName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeName !== undefined) {
                localVarQueryParameter['employeeName'] = employeeName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [impersonatorUserName] 
         * @param {string} [userName] 
         * @param {number} [durationInDays] 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authImpersonationLogsGet(impersonatorUserName?: string, userName?: string, durationInDays?: number, searchQuery?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseListResponseOfImpersonationLogModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authImpersonationLogsGet(impersonatorUserName, userName, durationInDays, searchQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoggOutRequest} [loggOutRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authLogoutPost(loggOutRequest?: LoggOutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutPost(loggOutRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePermissionDTO} [createPermissionDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPermissionPost(createPermissionDTO?: CreatePermissionDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewPermissionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPermissionPost(createPermissionDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewPermissionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPermissionsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPermissionsPermissionIdDelete(permissionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPermissionsPermissionIdDelete(permissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPermissionsPermissionIdGet(permissionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewPermissionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPermissionsPermissionIdGet(permissionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} permissionId 
         * @param {ViewPermissionDTO} [viewPermissionDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPermissionsPermissionIdPut(permissionId: number, viewPermissionDTO?: ViewPermissionDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewPermissionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPermissionsPermissionIdPut(permissionId, viewPermissionDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateRoleDTO} [createRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolePost(createRoleDTO?: CreateRoleDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewRoleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolePost(createRoleDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewRoleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolesRoleIdDelete(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolesRoleIdDelete(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolesRoleIdGet(roleId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewRoleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolesRoleIdGet(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {UpdateRoleDTO} [updateRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolesRoleIdPut(roleId: number, updateRoleDTO?: UpdateRoleDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewRoleDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolesRoleIdPut(roleId, updateRoleDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authTestGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authTestGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateUserRoleDTO} [createUserRoleDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserMapRolePost(createUserRoleDTO?: CreateUserRoleDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUserMapRolePost(createUserRoleDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateBulkUserRoleMapping} [createBulkUserRoleMapping] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUsersBulkMapRolePut(createBulkUserRoleMapping?: CreateBulkUserRoleMapping, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewUserRoleDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUsersBulkMapRolePut(createBulkUserRoleMapping, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user role information by employee name.
         * @param {string} [employeeName] The name of the employee (optional).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUsersGet(employeeName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupWiseRoleEmployeeInformationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUsersGet(employeeName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthorizationApiAuthImpersonationLogsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationLogsGet(requestParameters: AuthorizationApiAuthImpersonationLogsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseListResponseOfImpersonationLogModel> {
            return localVarFp.authImpersonationLogsGet(requestParameters.impersonatorUserName, requestParameters.userName, requestParameters.durationInDays, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthLogoutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authLogoutPost(requestParameters: AuthorizationApiAuthLogoutPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authLogoutPost(requestParameters.loggOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthPermissionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionPost(requestParameters: AuthorizationApiAuthPermissionPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewPermissionDTO> {
            return localVarFp.authPermissionPost(requestParameters.createPermissionDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsGet(options?: AxiosRequestConfig): AxiosPromise<Array<ViewPermissionDTO>> {
            return localVarFp.authPermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthPermissionsPermissionIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdDelete(requestParameters: AuthorizationApiAuthPermissionsPermissionIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authPermissionsPermissionIdDelete(requestParameters.permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthPermissionsPermissionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdGet(requestParameters: AuthorizationApiAuthPermissionsPermissionIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ViewPermissionDTO> {
            return localVarFp.authPermissionsPermissionIdGet(requestParameters.permissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthPermissionsPermissionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPermissionsPermissionIdPut(requestParameters: AuthorizationApiAuthPermissionsPermissionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewPermissionDTO> {
            return localVarFp.authPermissionsPermissionIdPut(requestParameters.permissionId, requestParameters.viewPermissionDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolePost(requestParameters: AuthorizationApiAuthRolePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ViewRoleDTO> {
            return localVarFp.authRolePost(requestParameters.createRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesGet(options?: AxiosRequestConfig): AxiosPromise<Array<ViewRoleDTO>> {
            return localVarFp.authRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthRolesRoleIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdDelete(requestParameters: AuthorizationApiAuthRolesRoleIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authRolesRoleIdDelete(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthRolesRoleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdGet(requestParameters: AuthorizationApiAuthRolesRoleIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<ViewRoleDTO> {
            return localVarFp.authRolesRoleIdGet(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthRolesRoleIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesRoleIdPut(requestParameters: AuthorizationApiAuthRolesRoleIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<ViewRoleDTO> {
            return localVarFp.authRolesRoleIdPut(requestParameters.roleId, requestParameters.updateRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTestGet(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authTestGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthUserMapRolePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserMapRolePost(requestParameters: AuthorizationApiAuthUserMapRolePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authUserMapRolePost(requestParameters.createUserRoleDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AuthorizationApiAuthUsersBulkMapRolePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersBulkMapRolePut(requestParameters: AuthorizationApiAuthUsersBulkMapRolePutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewUserRoleDTO>> {
            return localVarFp.authUsersBulkMapRolePut(requestParameters.createBulkUserRoleMapping, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user role information by employee name.
         * @param {AuthorizationApiAuthUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersGet(requestParameters: AuthorizationApiAuthUsersGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GroupWiseRoleEmployeeInformationDTO>> {
            return localVarFp.authUsersGet(requestParameters.employeeName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authImpersonationLogsGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthImpersonationLogsGetRequest
 */
export interface AuthorizationApiAuthImpersonationLogsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizationApiAuthImpersonationLogsGet
     */
    readonly impersonatorUserName?: string

    /**
     * 
     * @type {string}
     * @memberof AuthorizationApiAuthImpersonationLogsGet
     */
    readonly userName?: string

    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthImpersonationLogsGet
     */
    readonly durationInDays?: number

    /**
     * 
     * @type {string}
     * @memberof AuthorizationApiAuthImpersonationLogsGet
     */
    readonly searchQuery?: string
}

/**
 * Request parameters for authLogoutPost operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthLogoutPostRequest
 */
export interface AuthorizationApiAuthLogoutPostRequest {
    /**
     * 
     * @type {LoggOutRequest}
     * @memberof AuthorizationApiAuthLogoutPost
     */
    readonly loggOutRequest?: LoggOutRequest
}

/**
 * Request parameters for authPermissionPost operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthPermissionPostRequest
 */
export interface AuthorizationApiAuthPermissionPostRequest {
    /**
     * 
     * @type {CreatePermissionDTO}
     * @memberof AuthorizationApiAuthPermissionPost
     */
    readonly createPermissionDTO?: CreatePermissionDTO
}

/**
 * Request parameters for authPermissionsPermissionIdDelete operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthPermissionsPermissionIdDeleteRequest
 */
export interface AuthorizationApiAuthPermissionsPermissionIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthPermissionsPermissionIdDelete
     */
    readonly permissionId: number
}

/**
 * Request parameters for authPermissionsPermissionIdGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthPermissionsPermissionIdGetRequest
 */
export interface AuthorizationApiAuthPermissionsPermissionIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthPermissionsPermissionIdGet
     */
    readonly permissionId: number
}

/**
 * Request parameters for authPermissionsPermissionIdPut operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthPermissionsPermissionIdPutRequest
 */
export interface AuthorizationApiAuthPermissionsPermissionIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthPermissionsPermissionIdPut
     */
    readonly permissionId: number

    /**
     * 
     * @type {ViewPermissionDTO}
     * @memberof AuthorizationApiAuthPermissionsPermissionIdPut
     */
    readonly viewPermissionDTO?: ViewPermissionDTO
}

/**
 * Request parameters for authRolePost operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthRolePostRequest
 */
export interface AuthorizationApiAuthRolePostRequest {
    /**
     * 
     * @type {CreateRoleDTO}
     * @memberof AuthorizationApiAuthRolePost
     */
    readonly createRoleDTO?: CreateRoleDTO
}

/**
 * Request parameters for authRolesRoleIdDelete operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthRolesRoleIdDeleteRequest
 */
export interface AuthorizationApiAuthRolesRoleIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthRolesRoleIdDelete
     */
    readonly roleId: number
}

/**
 * Request parameters for authRolesRoleIdGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthRolesRoleIdGetRequest
 */
export interface AuthorizationApiAuthRolesRoleIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthRolesRoleIdGet
     */
    readonly roleId: number
}

/**
 * Request parameters for authRolesRoleIdPut operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthRolesRoleIdPutRequest
 */
export interface AuthorizationApiAuthRolesRoleIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof AuthorizationApiAuthRolesRoleIdPut
     */
    readonly roleId: number

    /**
     * 
     * @type {UpdateRoleDTO}
     * @memberof AuthorizationApiAuthRolesRoleIdPut
     */
    readonly updateRoleDTO?: UpdateRoleDTO
}

/**
 * Request parameters for authUserMapRolePost operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthUserMapRolePostRequest
 */
export interface AuthorizationApiAuthUserMapRolePostRequest {
    /**
     * 
     * @type {CreateUserRoleDTO}
     * @memberof AuthorizationApiAuthUserMapRolePost
     */
    readonly createUserRoleDTO?: CreateUserRoleDTO
}

/**
 * Request parameters for authUsersBulkMapRolePut operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthUsersBulkMapRolePutRequest
 */
export interface AuthorizationApiAuthUsersBulkMapRolePutRequest {
    /**
     * 
     * @type {CreateBulkUserRoleMapping}
     * @memberof AuthorizationApiAuthUsersBulkMapRolePut
     */
    readonly createBulkUserRoleMapping?: CreateBulkUserRoleMapping
}

/**
 * Request parameters for authUsersGet operation in AuthorizationApi.
 * @export
 * @interface AuthorizationApiAuthUsersGetRequest
 */
export interface AuthorizationApiAuthUsersGetRequest {
    /**
     * The name of the employee (optional).
     * @type {string}
     * @memberof AuthorizationApiAuthUsersGet
     */
    readonly employeeName?: string
}

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * 
     * @param {AuthorizationApiAuthImpersonationLogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authImpersonationLogsGet(requestParameters: AuthorizationApiAuthImpersonationLogsGetRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authImpersonationLogsGet(requestParameters.impersonatorUserName, requestParameters.userName, requestParameters.durationInDays, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthLogoutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authLogoutPost(requestParameters: AuthorizationApiAuthLogoutPostRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authLogoutPost(requestParameters.loggOutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthPermissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authPermissionPost(requestParameters: AuthorizationApiAuthPermissionPostRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authPermissionPost(requestParameters.createPermissionDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authPermissionsGet(options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authPermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthPermissionsPermissionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authPermissionsPermissionIdDelete(requestParameters: AuthorizationApiAuthPermissionsPermissionIdDeleteRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authPermissionsPermissionIdDelete(requestParameters.permissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthPermissionsPermissionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authPermissionsPermissionIdGet(requestParameters: AuthorizationApiAuthPermissionsPermissionIdGetRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authPermissionsPermissionIdGet(requestParameters.permissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthPermissionsPermissionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authPermissionsPermissionIdPut(requestParameters: AuthorizationApiAuthPermissionsPermissionIdPutRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authPermissionsPermissionIdPut(requestParameters.permissionId, requestParameters.viewPermissionDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authRolePost(requestParameters: AuthorizationApiAuthRolePostRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authRolePost(requestParameters.createRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authRolesGet(options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authRolesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthRolesRoleIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authRolesRoleIdDelete(requestParameters: AuthorizationApiAuthRolesRoleIdDeleteRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authRolesRoleIdDelete(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthRolesRoleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authRolesRoleIdGet(requestParameters: AuthorizationApiAuthRolesRoleIdGetRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authRolesRoleIdGet(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthRolesRoleIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authRolesRoleIdPut(requestParameters: AuthorizationApiAuthRolesRoleIdPutRequest, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authRolesRoleIdPut(requestParameters.roleId, requestParameters.updateRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authTestGet(options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authTestGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthUserMapRolePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authUserMapRolePost(requestParameters: AuthorizationApiAuthUserMapRolePostRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authUserMapRolePost(requestParameters.createUserRoleDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthorizationApiAuthUsersBulkMapRolePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authUsersBulkMapRolePut(requestParameters: AuthorizationApiAuthUsersBulkMapRolePutRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authUsersBulkMapRolePut(requestParameters.createBulkUserRoleMapping, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user role information by employee name.
     * @param {AuthorizationApiAuthUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authUsersGet(requestParameters: AuthorizationApiAuthUsersGetRequest = {}, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authUsersGet(requestParameters.employeeName, options).then((request) => request(this.axios, this.basePath));
    }
}
